import { Link, useForm } from '@inertiajs/react'

interface Account { id: number; name: string; slug: string; logo_url?: string | null }
interface Props { account: Account; token: string }

export default function CatalogSetPassword({ account, token }: Props) {
  const { data, setData, post, processing, errors } = useForm({
    password: '',
    password_confirmation: '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post(`/${account.slug}/portal/set_password/${token}`)
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white p-8 rounded-lg shadow">
        <Link href={`/${account.slug}/catalog`} className="flex items-center gap-2 font-bold text-lg mb-6 text-[#202020]">
          {account.logo_url && <img src={account.logo_url} className="h-8 w-8 object-contain bg-gray-100 rounded" />}
          {account.name}
        </Link>
        <h1 className="text-xl font-bold text-[#202020] mb-1">Configurar contraseña</h1>
        <p className="text-sm text-gray-500 mb-4">Elige una contraseña para acceder a tu cuenta</p>

        {errors && Object.keys(errors).length > 0 && (
          <div className="bg-red-50 text-red-600 p-3 rounded mb-4">
            {Object.entries(errors).map(([k, v], i) => (
              <p key={i}>{k}: {Array.isArray(v) ? v.join(', ') : v}</p>
            ))}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-3">
          <input type="password" placeholder="Contraseña" value={data.password}
            onChange={(e) => setData('password', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
            required minLength={6} />
          <input type="password" placeholder="Confirmar contraseña" value={data.password_confirmation}
            onChange={(e) => setData('password_confirmation', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
            required />
          <button type="submit" disabled={processing}
            className="w-full bg-[#FFC107] text-[#202020] py-2 rounded font-semibold hover:bg-[#e6ad06] disabled:opacity-50">
            {processing ? 'Guardando...' : 'Guardar contraseña'}
          </button>
        </form>

        <p className="text-xs text-gray-500 mt-4 text-center">
          <Link href={`/${account.slug}/catalog`} className="text-[#55ACEE] hover:underline">
            Volver al catálogo
          </Link>
        </p>
      </div>
    </div>
  )
}
